import React, { useState } from "react";
import FileSaver from "file-saver";
import apiClient from '../BaseUrl/apiClient'; // Adjust the import path as necessary
import { Button, CircularProgress } from "@mui/material";
import { decrypt } from "./cryptoUtil";

function ExportDataasCSV({
  exportEndpoint,
  buttonTitle = "Export Data",
  buttonColor = "primary",
  downloadedFileName = "ExportedFile.csv",
  postData = {}
}) {
 
  const [pageLoader, setPageLoader] = useState(false);
  const token = localStorage.getItem("token");
  const handleExportDetails = async () => {
    const username =  (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userId)||''; // ✅ Just read it directly here

    if (!postData.month || !postData.year) {
      alert("Please select both month and year.");
      return;
    }

    setPageLoader(true);
    try {
   // console.log("📤 Sending token:", token);
      // const response = await apiClient.post(
      //   exportEndpoint,
      //   {
      //     ...postData,
      //     userid: username
      //   },
      //   {
      //     responseType: "blob"
      //   }
      //   , {
      //               headers: {
      //                 'Content-Type': 'application/json',
      //                 "Authorization": `Bearer ${token}`, // optional, set default headers
      //               },
      //             }
      // );



const response = await apiClient.post(
  exportEndpoint,
  {
    ...postData,
    userid: username,
  },
  {
    responseType: "blob",  // 👈 same object
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`, // 👈 will now be sent
    },
  }
);



      const blob = new Blob([response.data], {
        type: "text/csv;charset=utf-8;"
      });
     // console.log("Exported data:", blob);


     //const token = localStorage.getItem("token");



      FileSaver.saveAs(blob, downloadedFileName);
    } catch (error) {
      console.error("Error exporting data:", error);
      alert("Failed to export data. Please try again.");
    }
    setPageLoader(false);
  };

  return (
    <div>
      {pageLoader && (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      )}
      <Button
        onClick={handleExportDetails}
        disabled={pageLoader || !postData.month || !postData.year}
        variant="contained"
        color={buttonColor}
      >
        {buttonTitle}
      </Button>
    </div>
  );
}

export default ExportDataasCSV;
